module.exports = __webpack_public_path__ + "img/lastiki.88d8d37a.svg";